import { ISalePageDetailV2Response } from '@/api/types';
import { Column } from '@vuddy/components';
import {
  GachaContentIntroduce,
  GachaContentNotice,
  GachaContentProbability,
} from './content';
import { GachaContentStock } from './content/GachaContentStock';
import GachaStockRanking from './content/GachaStockRanking';
import * as styles from './contentSection.css';

interface IGachaContentSectionProps {
  salePage: ISalePageDetailV2Response;
}

export const GachaContentSection = ({
  salePage,
}: IGachaContentSectionProps) => {
  return (
    <Column gap="gap_xl" paddingTop="padding_large" className={styles.wrapper}>
      <GachaContentIntroduce
        description={salePage.description}
        requestDeliveryAddressTimeRange={
          salePage.gacha?.requestDeliveryAddressTimeRange
        }
      />
      <GachaStockRanking salePageId={salePage.id} />

      {salePage.gacha?.logicType === 'PROBABILITY' && (
        <GachaContentProbability
          isProxyCompleteAllowed={salePage.gacha.isProxyCompleteAllowed}
          rewards={salePage.gacha.rewards}
        />
      )}
      {salePage.gacha?.logicType === 'STOCK' && (
        <>
          <GachaContentStock
            isProxyCompleteAllowed={salePage.gacha.isProxyCompleteAllowed}
            rewards={salePage.gacha.rewards}
          />
        </>
      )}
      <GachaContentNotice salePageId={salePage.id} salePage={salePage} />
    </Column>
  );
};
